export const FILTER_TYPE = {
  ALL: { text: "全て", value: 1 },
  SHARE_RANK: { text: "シェア上位20店舗", value: 2 },
  BASE_AND_SHARE_RANK: { text: "基準店舗とシェアが近い20店舗", value: 3 },
} as const;
